<template>
<b-container>
<b-card>
  <h1 class="mb-3">Application Users</h1>
  <b-button class="mb-3" :to="{name:'user-detail', params: { username: null}}" variant="primary"> Create User <font-awesome-icon icon="plus" /></b-button>
        <b-row class="mb-3 mt-3">
            <b-col>
                                <b-input-group>
                <b-input-group-prepend is-text>
                  <font-awesome-icon :icon="['fa', 'search']"/>
                  </b-input-group-prepend>
                <b-form-input v-model="searchTerm" placeholder="Search for Users" @input="delaySearchUsers"></b-form-input>
                                </b-input-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-table
                    :fields="table.fields"
                    :items="table.items"
                    :busy="table.isBusy"
                    class="mb-3"
                    show-empty
                    empty-text="No Users to show"
                    :tbody-tr-class="rowClass"
                    outlined>
                    <template v-slot:cell(edit)="row">
                        <b-button :key="row.item.uid" :to="{name: 'user-detail', params: { userName: row.item.username}}"  variant="outline-secondary">
                        <font-awesome-icon icon="edit" />
                        </b-button>
                    </template>
                        <template #cell(last_login)="row">
                            <span :id="'tooltip-updated-' + row.index" v-if="row.item.last_login!==null">{{$moment.utc(row.item.last_login).local().fromNow()}}</span>
                            <b-tooltip :target="'tooltip-updated-' + row.index" triggers="hover" v-if="row.item.last_login!==null">
                                {{$moment.utc(row.item.last_login).local().format('llll')}}
                            </b-tooltip>
                        </template>
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col align="center">
        <b-button-group v-if="pages.length>1">
            <b-button @click="searchUsers(currentPage-1)">Prev</b-button>
            <b-button @click="searchUsers(currentPage+1)">Next</b-button>
        </b-button-group>
            </b-col>
        </b-row>
</b-card>
</b-container>
</template>canListUsers
<script>
import { UserApi } from "@/api/userApi";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";
import _ from "lodash";
export default {
    name: "UserList",
    props: {},
    mixins: [userMixin],
    data () {
        return {
            searchTerm: null,
            currentPage: 0,
            lastPage: 0,
            nextPage : {
                aux_id : null,
                pk_id : null,
                gsi_pk: null,
                gsi_sk: null
            },
            paging: {
                currentPage: 0,
                lastPage:0,
                nextPage:0,
                searchTerm:null
            },
            pages: [],
            table: {
                id:"user-list",
                fields: [,
                    {
                        key: "username",
                        label: "Username"
                    },
                    {
                        key: "full_name",
                        label: "Full Name"
                    },
                    {
                        key: "email",
                        label: "E-Mail"
                    },
                    {
                      key: 'last_login',
                      label: 'Last Logged In'
                    },
                    {
                        key: "edit",
                        label: "Edit"
                    }

                ],
                items: [],
                isBusy: false
            }
        }
    },
    async mounted() {
        this.show = true;
        this.pages.push(this.nextPage);
        await this.searchUsers(0);
        this.show = false;

    },
    methods: {
        async searchUsers(page) {
            if(page < 0){
                return ;
            }
            if (page > this.pages.length - 1)
            {
                return;
            }
            const payload = this.pages[page];
            payload.search_term = this.searchTerm;
            this.table.isBusy = true;
            try{
                const { data } = await UserApi.getUserList(payload);
                //console.log(data);
                if(data.last_evaluated_key !== null){
                    if(!this.existInPageList(data.last_evaluated_key, this.pages))
                        this.pages.push(data.last_evaluated_key);
                }
                this.table.items = data.result;
                this.currentPage = page;
            } catch (e) {
                const msg = "Error searching for users";
                handleError(e, msg);
            } finally {
                this.table.isBusy = false;
            }
        },
        async filterUsers() {
            this.pages = [];
            this.currentPage = 0;
            this.lastPage = 0;
            this.pages.push(this.nextPage);
            await this.searchUsers(0);
        },
        existInPageList(obj, list) {
            if(list.length==0) return false;
            var i;
            for (i = 0; i < list.length; i++) {
                if (list[i].pk_id === obj.pk_id && list[i].aux_id === obj.aux_id) {
                    return true;
                }
            }
            return false;

        },
        rowClass(item, type) {
            if (!item || type !== 'row') return;
            if (item.disabled) return 'contact-disabled';
        },
      delaySearchUsers: _.debounce(async function() {
        await this.searchUsers(0);
      },500)
    },


}
</script>
<style lang="scss">
.contact-disabled {
  color: #757575;
  background-color: #f5f5f5 !important;
}
</style>
